import classNames from "classnames";
import { IItem } from "../../types/common.interface";
import "./index.scss";

type Props = {
  menus: IItem[];
  onClick: (props: IItem | null) => void;
  selected: IItem | null;
  canNull?: boolean;
  themeColor?: string;
};

function CustomRadioButtonGroup({
  menus,
  onClick,
  selected,
  canNull = true,
  themeColor,
}: Props) {
  return (
    <nav id="radio-menu-container">
      {menus.map((menu, index) => {
        return (
          <div
            style={{
              backgroundColor: selected?.value === menu.value ? themeColor : "",
            }}
            onClick={() =>
              onClick(menu?.value === selected?.value && canNull ? null : menu)
            }
            key={`menu-${menu.value}-${index}`}
            className={classNames("menu-bg", {
              selectedMenu: selected?.value === menu.value,
            })}
          >
            <h4>{menu.name}</h4>
          </div>
        );
      })}
    </nav>
  );
}

export default CustomRadioButtonGroup;
